module.exports = __webpack_public_path__ + "static/media/buy_customer_support_4.78606653.png";